<template>
    <v-sheet> 
        <v-toolbar dense flat
            color="secondary">
            <v-toolbar-title>{{$t("malfaction_report_by_truck")}}</v-toolbar-title>
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="4">
                    <TruckTypeAutocomplete
                        label="Truck Type"
                        v-model="params.truck_type_id"
                        outlined
                        dense
                        hide-details
                        single-line
                        background-color="white"
                        />
                </v-col>
                <v-col cols="4">
                    <MalfactionsAutocomplete
                        :label="$t('FAILURES')"
                        v-model="params.malfaction_id"
                        outlined
                        dense
                        hide-details
                        background-color="white"
                        />
                </v-col>
            </v-row>
        </v-toolbar>
        <v-simple-table dense v-if="!loading">
            <thead>
                <tr>
                    <th>{{$t("TRUCK_PLATE")}}</th>
                    <th>{{$t("TRUCK_TYPE")}}</th>
                    <th>{{$t("FAILURES")}}</th>
                    <th>{{$t("COUNT")}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(d, i) in data" :key="i" @click="handleClick($event, d)" v-ripple>
                    <td>{{d.plate_number}}</td>
                    <td>{{d.truck_type}}</td>
                    <td>{{d.description}}</td>
                    <td>{{d.count}}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <div v-else class="pa-4">
            <v-progress-linear
                class="my-4"
                indeterminate
                color="yellow darken-2"
            ></v-progress-linear>
            <div class="text-center">{{$t("please_wait")}}</div>
        </div>
    </v-sheet>
</template>

<script>
import MalfactionsAutocomplete from './MalfactionsAutocomplete';
import TruckTypeAutocomplete from './TruckTypeAutocomplete';
import { getMalfactionsReportByTruck } from './../services/reports';
export default {
    name: "MalfactionsReportByTruck",
    components: { MalfactionsAutocomplete, TruckTypeAutocomplete },
    props: {
        query: Object
    },
    data() {
        return {
            loading: false,
            data: [],
            params: {
                malfaction_id: null,
                truck_type_id: null,
            }
        }
    },
    watch: {
        query: {
            handler() {
                this.setParams(this.query);
            },
            deep: true
        },
        params: {
            handler() {
                this.fetchData();
            },
            deep: true
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let resp = await getMalfactionsReportByTruck(this.params);
            this.data = resp.data;
            this.loading = false;
        },
        setParams(query) {
            this.params = { ...query };
            if(this.params.malfaction_id) this.params.malfaction_id = Number(this.params.malfaction_id);
            if(this.params.truck_type_id) this.params.truck_type_id = Number(this.params.truck_type_id);
        },
        handleClick(e, { malfaction_id, truck_id }) {
            this.$router.push({ path: "/reports/malfactions-report-by-truck-details", query: { malfaction_id, truck_id } })
        }
    },
    created() {
        this.setParams(this.query);
        if(this.query.truck_type_id && this.query.malfaction_id) {
            this.truck_type_id = this.query.truck_type_id;
            this.malfaction_id = this.query.malfaction_id;
            this.fetchData();
        }
    }
}
</script>

<style>

</style>